import { Link } from "react-router";
import Button from "../../components/ui/button/Button";

const ProposalCreateRestaurant = () => {
 return (
  <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8">
    <div className="relative overflow-hidden rounded-[36px] border border-slate-200 bg-white p-8 shadow-[0_20px_60px_-15px_rgba(0,0,0,0.15)] transition-all duration-300 dark:border-white/10 dark:bg-[#111827] sm:p-12">
      
      <div className="absolute right-0 top-0 h-72 w-72 rounded-full bg-indigo-500/10 blur-3xl" />

      <div className="relative grid gap-10 lg:grid-cols-2 lg:items-center">
        
        <div>
          <div className="inline-flex items-center rounded-full border border-indigo-500/20 bg-indigo-500/10 px-4 py-1 text-sm font-medium text-indigo-600 dark:text-indigo-300">
            Restaurant Management
          </div>

          <h2 className="mt-6 text-4xl font-black leading-tight tracking-tight text-slate-900 dark:text-white sm:text-5xl">
            Create Your First Restaurant
          </h2>

          <p className="mt-6 max-w-2xl text-lg leading-8 text-slate-600 dark:text-slate-400">
            Add your restaurant information, upload a restaurant photo,
            create menus, generate QR codes, and start serving guests
            with a modern digital experience.
          </p>

          <div className="mt-8 flex flex-wrap gap-4">
            <Link to='/restaurants/new'>
              <Button 
                size="md" 
                variant="primary"
                className="my-6"
              >
                Create Restaurant
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  </section>
 )
}

export default ProposalCreateRestaurant;
